import "./OutputDocumentsPanel.scss";

import { LyneButton } from "components/Lyne/LyneButton";
import { SlidingPanel } from "components/SlidingPanel/SlidingPanel";
import { useOutputDocumentsPanel, useTranslations } from "providers";
import React from "react";

import { OutputDocumentsContent } from "./OutputDocumentsContent";

export const OutputDocumentsPanel: React.FC = () => {
  const i18n = useTranslations();
  const { showOutputDocumentsPanel, setShowOutputDocumentsPanel, isGenerating, generatedDocuments } =
    useOutputDocumentsPanel();

  const handleClose = () => {
    setShowOutputDocumentsPanel(false);
  };

  const openImmediately = (url: string) => {
    try {
      const ref = window.open(url);
      ref?.focus();

      setTimeout(() => {
        handleClose();
      }, 200);
    } catch {
      // popup blocker may prevent opening
    }
  };

  if (!showOutputDocumentsPanel) {
    return null;
  }

  return (
    <div>
      <SlidingPanel
        isOpen
        onClose={handleClose}
        panelContainerClassName="output-documents-panel"
        header={<h1 className="pb-3">{i18n.OutputDocuments_Header}</h1>}
        footer={
          <LyneButton onClick={handleClose} kind="ghost">
            {i18n.Actions_Close}
          </LyneButton>
        }
      >
        <OutputDocumentsContent
          isLoading={isGenerating}
          documents={generatedDocuments}
          onOpenImmediately={openImmediately}
        />
      </SlidingPanel>
    </div>
  );
};
